import React, { useEffect } from 'react'
import { hot } from 'react-hot-loader/root'
import AOS from 'aos'
import { Routes } from './Config/routes'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { ConfigProvider } from 'antd'
import enUS from 'antd/es/locale/en_US'
import itIT from 'antd/es/locale/it_IT'
import { useSelector } from 'react-redux'
import './App.css'
import 'antd/dist/antd.min.css'
import { registerServiceWorker } from './ServiceWorker'

AOS.init()

const theme = createTheme({
  palette: {
    primary: {
      main: '#007aff',
      secondMain: '#1890ff'
    }
  }
})

const App = () => {
  const language = useSelector((state) => state.language?.language) || 'en'

  useEffect(() => {
    registerServiceWorker()
  }, []);

  return (
    <div>
      <ThemeProvider theme={theme}>
        <ConfigProvider locale={language === 'it' ? itIT : enUS}>
          <Routes />
        </ConfigProvider>
      </ThemeProvider>
    </div>
  )
}

export default hot(App)
